import { Switch, SwitchProps } from '@mui/material';
import { useField } from 'formik';

export type FormikSwitchProps = Omit<
  SwitchProps,
  'checked' | 'onChange' | 'name'
> & {
  name: string;
};

export const FormikSwitch = ({ name, ...props }: FormikSwitchProps) => {
  const [field, , helpers] = useField<boolean>({ name, type: 'checkbox' });

  return (
    <Switch
      {...props}
      name={name}
      checked={field.checked ?? Boolean(field.value)}
      onChange={(_e, checked) => helpers.setValue(checked)}
      onBlur={field.onBlur}
    />
  );
};
